import React from 'react';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const appVersion = process.env.REACT_APP_VERSION || "0.0.0-beta"; 

  return (
    <footer className="bg-white text-center text-xs text-gray-500 py-2 border-t">
      &copy; {currentYear} NuGate Bantech Systems. All rights reserved. | Version {appVersion}
    </footer>
  );
};

export default Footer;
